export { default, createFilterOptions } from './useAutocomplete';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/lab/esm/useAutocomplete/index.js
// module id = 292
// module chunks = 0